import React from 'react';
import { Button, SparkIcon, TooltipTrigger } from '@spark';
import RunAllButton from './RunAllButton';

/**
 * Top toolbar of the Playground workspace (Figma 335:1065): breadcrumb on
 * the left; GPU session, Query file, Add Model, and Run all on
 * the right.
 */
const PlaygroundTopBar = ({
    projectName,
    taskName,
    onExit,
    canAddModel,
    onAddModel,
    onRunAll,
    isRunning,
    runDisabled,
    gpuControl,
    queryFileControl,
    runDisabledReason,
}) => {
    const breadcrumbText = `${[projectName, taskName ? `Task: ${taskName}` : null]
        .filter(Boolean)
        .join('  >  ')}${taskName ? '  >' : ''}`;
    return (
        <div className="pg-toolbar fs-unmask">
            <div className="pg-toolbar__inner">
                {onExit ? (
                    <TooltipTrigger text="Back to task" placement="bottom">
                        <button
                            type="button"
                            className="pg-toolbar__breadcrumb pg-toolbar__breadcrumb--link"
                            onClick={onExit}
                        >
                            {breadcrumbText}
                        </button>
                    </TooltipTrigger>
                ) : (
                    <div className="pg-toolbar__breadcrumb">{breadcrumbText}</div>
                )}
                <div className="pg-toolbar__spacer" />
                <div className="pg-toolbar__actions">
                    {gpuControl}
                    {queryFileControl}
                    <TooltipTrigger
                        text={canAddModel ? 'Compare another model' : 'Up to 3 models can be compared'}
                        placement="bottom"
                    >
                        <span>
                            <Button
                                variant="secondary"
                                size="small"
                                disabled={!canAddModel}
                                startIcon={<SparkIcon slug="plus" size="small" />}
                                onClick={onAddModel}
                            >
                                Add Model
                            </Button>
                        </span>
                    </TooltipTrigger>
                    <RunAllButton
                        onRunAll={onRunAll}
                        isRunning={isRunning}
                        runDisabled={runDisabled}
                        runDisabledReason={runDisabledReason}
                    />
                </div>
            </div>
        </div>
    );
};

export default PlaygroundTopBar;
